export enum ValidationStatus {
  READY = "READY",
  SAVE_DRAFT = "SAVE_DRAFT",
  VALIDATING = "VALIDATING",
  RELOAD = "RELOAD",
}

export type SurveyData = {
  formData: unknown;
  isValid: boolean;
  tabId: string;
};
